'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';
import { useAudio } from '../hooks/useAudio';

interface GameCardProps {
  color: string;
  delay?: number;
  href: string;
  icon: ReactNode;
  title: string;
}

/**
 * Large clickable game card for the landing page.
 * @param props - Card props.
 * @param props.color - Background color class.
 * @param props.delay - Animation delay in ms.
 * @param props.href - Link to game page.
 * @param props.icon - SVG icon for the game.
 * @param props.title - Game title.
 */
export const GameCard = ({ title, href, icon, color, delay = 0 }: GameCardProps) => {
  const { playSound } = useAudio();

  const handleClick = () => {
    playSound('tap');
  };

  return (
    <Link
      href={href}
      onClick={handleClick}
      className="animate-bounce-in touch-target"
      style={{ animationDelay: `${delay}ms` }}>
      <div
        className={`${color} rounded-2xl sm:rounded-3xl p-3 sm:p-4 shadow-lg transform transition-transform duration-200 active:scale-95 hover:scale-105 flex flex-col items-center gap-2 sm:gap-3`}>
        <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 flex items-center justify-center">{icon}</div>
        <span className="text-white text-sm sm:text-base lg:text-lg font-bold text-center drop-shadow-md leading-tight">
          {title}
        </span>
      </div>
    </Link>
  );
};
